// extracted by mini-css-extract-plugin
module.exports = {"NavigationBar":"NavigationBar_NavigationBar__2OpPc","menu_item_name":"NavigationBar_menu_item_name__1uloH","menu_item_icon":"NavigationBar_menu_item_icon__2BCqG"};